import axios from 'axios';

export default {
  state: {
    pickupPoint: {},
    loading: false,
    error: null,
    pickupPointLoaded: false
  },
  mutations: {
    SET_PICKUP_POINT(state, pickupPoint) {
      state.pickupPoint = pickupPoint;
      state.pickupPointLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_PICKUP_POINT_LOADING(state, status) {
      state.pickupPointLoading = status;
    },
    UNSET_PICKUP_POINT(state) {
      state.pickupPointLoaded = false;
      state.pickupPointLoading = false;
      state.pickupPoint = {};
    },
    SET_PICKUP_POINT_ERROR(state, error) {
      state.pickupPointError = error;
    }
  },
  actions: {
    async fetchPickupPoint({ commit, state }, id) {
      // Проверяем, были ли категории уже загружены
      if (state.loaded && state.pickupPoint) {
        //return; // Если данные уже загружены, прекращаем выполнение
      }

      try {
        commit('SET_PICKUP_POINT_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/order/pickup/', {params: {city: id}});
        commit('SET_PICKUP_POINT', response.data.data);
        commit('SET_PICKUP_POINT_ERROR', null);
      } catch (error) {
        commit('SET_PICKUP_POINT_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching pickupPoint:', error);
      } finally {
        commit('SET_PICKUP_POINT_LOADING', false);
      }
    }
  },
  getters: {
    pickupPoint: state => state.pickupPoint,
    pickupPointLoading: state => state.pickupPointLoading,
    pickupPointError: state => state.pickupPointError,
    pickupPointLoaded: state => state.pickupPointLoaded
  }
}